module.exports = "<ea-role-page company-filter-enabled=\"$ctrl.companyFilterEnabled\"></ea-role-page>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaRole/eaRolePage/eaRolePageModule.html
// module id = 1065
// module chunks = 12